<template>
<div>
    <v-container fluid>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <div class="d-flex justify-end">
      <v-btn 
        color="brand onBrand--text"
        dark
        small
        class="mt-2,mb-2"
        style="margin-right:0.5em;border-radius:8px;margin-top:-7px"
        @click="videoDialog = true"
      >
      <v-icon left>mdi-youtube</v-icon>
      Watch Tutorial
      </v-btn>
      </div>

        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <!-- Child Selection and Place Order -->
        <v-card class="box">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Student Orders</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-btn v-if="child" color="brandLight" class="ml-4" @click="placeOrder()">
                    <v-icon left>mdi-plus-circle</v-icon>
                    Place Order 
                </v-btn>
            </v-toolbar>
            <v-row justify="center" dense>
                <v-col cols="12" sm="4" md="4">
                    <p>
                        <v-icon color="error">*</v-icon><b>Select Student</b>
                    </p>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="child" :items="child_list" 
                    item-text="name" item-value="lid" label="Select Student" outlined persistent-hint hint="Please Select Student"  @change="onStudentChange" 
                    />
                </v-col>
            </v-row>
            <!-- {{ studentDetails }} -->
            <table class="styled-table" v-if="studentDetails">
                <thead>
                    <tr>
                        <th>PRN</th>
                        <th>Student Name</th>
                        <th>Standard</th>
                        <th>Division</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="studentDetails">
                        <td>{{ studentDetails.registration_number }}</td>
                        <td>{{ studentDetails.learner_name }}</td>
                        <td>{{ studentDetails.standard }}</td>
                        <td>{{ studentDetails.division }}</td>
                    </tr>
                </tbody>
            </table>
        </v-card>

        <!-- Orders Table -->
        <v-card class="box" v-if="orders_list.length > 0">
            <v-data-table :headers="headers" id="my-table-id" :search="searchQuery" :items="orders_list" class="elevation-1">
                <template v-slot:top>
                    <v-toolbar flat class="toolbar">
                        <v-toolbar-title>Orders</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                        <!-- Search Box -->
                        <v-text-field v-model="searchQuery" append-icon="search" rounded label="search" class="search-bar" background-color="white" color="white" hide-details></v-text-field>
                        <v-btn color="white" @click="fnExcelReport('my-table-id', 'MyOrders')">
                            <v-icon left>mdi-file-excel</v-icon> Export
                        </v-btn>
                    </v-toolbar>
                </template>
                <!-- Order Items Column -->
                <template v-slot:[`item.viewOrderItems`]="{ item }">
                    <v-btn color="black" text @click="showOrderItems(item)">
                        <v-icon left>mdi-eye</v-icon>
                    </v-btn>
                </template>

                <!-- Actions Column -->
                <template v-slot:[`item.action`]="{ item }">
                    <!-- Track Order Button with Icon -->
                    <v-btn color="green" text @click="getOrderTrackingDetails(item.id)">
                        <v-icon left>mdi-truck-delivery</v-icon> Track
                    </v-btn>
                    <!-- Cancel Order Button with Icon -->
                    <span v-if="item.orderstatus=='Pending'">
                        <v-btn color="red" text @click="cancelOrder(item.id)">
                            <v-icon left>mdi-cancel</v-icon> Cancel
                        </v-btn>
                    </span>
                    <span v-else>--</span>
                </template>
                <template v-slot:[`item.viewDetails`]="{ item }">
                    <span v-if="item.invoices.length > 0">
                        <v-btn v-for="invoice in item.invoices" :key="invoice.id" color="black" text @click="showInvoice(invoice.id)" class="ma-1">
                            <v-icon left>mdi-eye</v-icon>
                        </v-btn>
                    </span>
                    <span v-else>--</span>
                </template>

                <!-- Add Delivery Instructions Column -->
                <template v-slot:[`item.delivery_instructions_action`]="{ item }">
                    <!-- Add Delivery Instructions Button with Icon -->
                    <v-btn @click="openDeliveryDialog(item)" color="primary">
                        <v-icon left>mdi-plus-circle</v-icon> Add Instructions
                    </v-btn>
                </template>
                <template v-slot:[`item.isactive`]="{ item }">
                    <span v-if="item.isactive">
                        <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                    </span>
                    <span v-else>
                        <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                    </span>
                </template>
            </v-data-table>
        </v-card>
        <v-dialog v-model="orderItemsDialog" max-width="800px">
            <v-card class="box">
                <v-toolbar flat class="toolbar">
                    <v-toolbar-title>Order Items</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-divider></v-divider>
                <v-card-text>
                    <v-data-table :headers="orderItemsHeaders" :items="selectedOrderItems" dense class="elevation-1">
                    </v-data-table>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red" text @click="orderItemsDialog = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogAddOrder" fullscreen>
            <v-card>
                <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title>
                        <strong> Place Order </strong>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn fab small color="white" outlined icon @click="closeDialog">
                        <v-icon> mdi-close </v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card class="box">
                    <table class="styled-table">
                        <thead>
                            <tr>
                                <th>PRN</th>
                                <th>Student Name</th>
                                <th>Standard</th>
                                <th>Division</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="studentDetails">
                                <td>{{ studentDetails.registration_number }}</td>
                                <td>{{ studentDetails.learner_name }}</td>
                                <td>{{ studentDetails.standard }}</td>
                                <td>{{ studentDetails.division }}</td>
                            </tr>
                        </tbody>
                    </table>
                </v-card>
                <br>
                <v-card class="box">
                    <v-row justify="center" dense>
                        <!-- Category Autocomplete -->
                        <v-col sm="2">
                            <v-icon color="error">*</v-icon>
                            <v-autocomplete color="#0F2027" dense rounded required v-model="itemCategory" :items="itemCategoryList" item-text="name" item-value="id" label="Category" outlined @click="filterItems" />
                        </v-col>
                        <!-- Item Autocomplete (Filtered by Category) -->
                        <!-- <v-col sm="2" v-if="filteredItemList && filteredItemList.length">
                            <v-icon color="error">*</v-icon>
                            <v-autocomplete color="#0F2027" dense rounded required v-model="cartitems" :items="filteredItemList" item-text="name" item-value="id" label="Item" outlined multiple />
                        </v-col> -->
                    </v-row>
                </v-card>
                <br>
                <v-card class="box" v-if="filteredItemList.length">
                    <!-- <v-data-table dense :headers="headersItems" :items="filteredItemList" item-value="id" class="elevation-1 mytable">

                        <template v-slot:[`item.item_image`]="{ item }">
                            <span v-if="item.image_file_path">
                                <v-icon color="blue" class="cursor-pointer" @click="viewImage(item.image_file_path)">
                                    visibility
                                </v-icon>
                            </span>
                            <span v-else>--</span>
                        </template>
                        <template v-slot:[`item.sizechart_file_path`]="{ item }">
                            <span v-if="item.sizechart_file_path">
                                <v-icon color="blue" class="cursor-pointer" @click="viewImage(item.sizechart_file_path)">
                                    visibility
                                </v-icon>
                            </span>
                            <span v-else>--</span>
                        </template>
                        <template v-slot:[`item.select`]="{ item }">
                            <v-checkbox v-model="item.selected" :disabled="true" />
                        </template>

                        <template v-slot:[`item.quantity`]="{ item }">
                            <v-text-field rounded outlined type="number" dense v-model="item.quantity" :disabled="true" :rules="[value => value > 0 || 'Quantity must be greater than 0']" />
                        </template>
                        <template v-slot:[`item.size_label`]="{ item }">
                            <v-select class="mt-4" v-if="item.is_size_applicable" v-model="item.selectedSize" :items="getSizeLabels(item)" item-text="name" item-value="id" label="Size" dense rounded outlined required @change="updateSelectedItemId(item)" />
                        </template>

                        <template v-slot:[`item.total_price`]="{ item }">
                            <span>{{ item.total_price }}</span>
                        </template>

                    </v-data-table> -->
                    <!-- <v-data-table dense :headers="headersItems" :items="filteredItemList" item-value="id" class="elevation-1 mytable">

                        <template v-slot:[`item.size_label`]="{ item }">
                            <v-select class="mt-4" v-if="item.is_size_applicable" v-model="item.selectedSize" :items="getSizeLabels(item)" item-text="name" item-value="id" label="Size" dense rounded outlined required @change="updateSelectedItemId(item)" />
                        </template>

                        <template v-slot:[`item.total_price`]="{ item }">
                            <span v-if="!item.is_size_applicable || item.selectedSize">{{ item.total_price }}</span>
                        </template>

                        <template v-slot:[`item.item_image`]="{ item }">
                            <span v-if="(!item.is_size_applicable || item.selectedSize) && item.image_file_path">
                                <v-icon color="blue" class="cursor-pointer" @click="viewImage(item.image_file_path)">
                                    visibility
                                </v-icon>
                            </span>
                            <span v-else>--</span>
                        </template>
                        <template v-slot:[`item.select`]="{ item }">
                            <v-checkbox v-model="item.selected" :disabled="true" />
                        </template>
                        <template v-slot:[`item.quantity`]="{ item }">
                            <v-text-field rounded outlined type="number" dense v-model="item.quantity" :disabled="true" :rules="[value => value > 0 || 'Quantity must be greater than 0']" />
                        </template>
                        <template v-slot:[`item.description`]="{ item }">
                            <span v-if="!item.is_size_applicable || item.selectedSize">{{ item.description }}</span>
                        </template>

                        <template v-slot:[`item.price`]="{ item }">
                            <span v-if="!item.is_size_applicable || item.selectedSize">{{ item.price }}</span>
                        </template>

                    </v-data-table> -->

                    <v-data-table dense :headers="dynamicHeaders" :items="filteredItemList" item-value="id" class="elevation-1 mytable">

                        <!-- Image Column -->
                        <template v-slot:[`item.item_image`]="{ item }">
                            <span v-if="item.image_file_path">
                                <v-icon color="blue" class="cursor-pointer" @click="viewImage(item.image_file_path)">
                                    visibility
                                </v-icon>
                            </span>
                            <span v-else>--</span>
                        </template>
                        <template v-slot:[`item.size_label`]="{ item }">
                            <v-select class="mt-4" v-if="item.is_size_applicable" v-model="item.selectedSize" :items="getSizeLabels(item)" item-text="name" item-value="id" label="Size" dense rounded outlined required @change="updateSelectedItemId(item)" />
                        </template>
                        <!-- Size Chart Column -->
                        <template v-slot:[`item.sizechart_file_path`]="{ item }">
                            <span v-if="item.sizechart_file_path">
                                <v-icon color="blue" class="cursor-pointer" @click="viewImage(item.sizechart_file_path)">
                                    visibility
                                </v-icon>
                            </span>
                            <span v-else>--</span>
                        </template>

                        <!-- Checkbox Selection (Disabled if allow_all_items_compulsory is true) -->
                        <template v-slot:[`item.select`]="{ item }">
                            <v-checkbox v-model="item.selected" :disabled="allow_all_items_compulsory" />
                        </template>

                        <!-- Quantity Field (Disabled if allow_all_items_compulsory is true) -->
                        <template v-slot:[`item.quantity`]="{ item }">
                            <v-text-field rounded outlined type="number" dense v-model="item.quantity" @input="updateTotalPrice(item)" :disabled="allow_all_items_compulsory" :rules="[
            value => value > 0 || 'Quantity must be greater than 0',
            value => value <= item.availableStockQuantity || `Only ${item.availableStockQuantity} items available`
        ]" />
                        </template>

                        <!-- Total Price -->
                        <template v-slot:[`item.total_price`]="{ item }">
                            <span>{{ item.total_price }}</span>
                        </template>

                    </v-data-table>

                    <v-row class="mt-4" align="center">
                        <v-col cols="4" class="text-center"></v-col>
                        <v-col cols="2" class="text-center">
                            <v-btn color="primary" :disabled="isProceedDisabled" @click="proceed">Proceed</v-btn>
                        </v-col>
                        <v-col cols="2" class="text-center">
                            <v-btn color="primary" :disabled="isProceedDisabled" @click="addItemToCart">Add To
                                Cart</v-btn>
                        </v-col>
                        <v-col cols="2" class="text-center"></v-col>
                        <v-col cols="2" class="text-right">
                            <h4>Total: {{ calculateTotal }}</h4>
                        </v-col>
                    </v-row>
                </v-card>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogCartSummary" fullscreen>
            <v-card>
                <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title>
                        <strong> My Cart </strong>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn fab small color="white" outlined icon @click="closeCartDialog">
                        <v-icon> mdi-close </v-icon>
                    </v-btn>
                </v-toolbar>

                <v-card class="box">
                    <!-- Cart Items Table -->
                    <v-data-table dense :headers="headersCart" :items="cartItems" item-value="id" class="elevation-1 mytable">
                        <template v-slot:[`item.item_image`]="{ item }">
                            <span v-if="item.image_file_path">
                                <v-icon color="blue" class="cursor-pointer" @click="viewImage(item.image_file_path)">
                                    visibility
                                </v-icon>
                            </span>
                            <span v-else>--</span>
                        </template>

                        <!-- Non-editable Quantity -->
                        <template v-slot:[`item.quantity`]="{ item }">
                            <v-btn small icon color="blue" @click="updateQuantity(item,'remove')" :disabled="item.quantity <= 1">
                                <v-icon>mdi-minus</v-icon>
                            </v-btn>
                            <span>{{ item.quantity }}</span>
                            <v-btn small icon color="blue" @click="updateQuantity(item,'add')">
                                <v-icon>mdi-plus</v-icon>
                            </v-btn>
                        </template>

                        <template v-slot:[`item.total_price`]="{ item }">
                            <span>{{ item.total_price }}</span>
                        </template>

                        <!-- Delete Item -->
                        <template v-slot:[`item.action`]="{ item }">
                            <v-icon color="red" @click="removeFromCart(item)">mdi-delete</v-icon>
                        </template>
                    </v-data-table>

                    <!-- Total Price -->
                    <v-row justify="end" class="mt-4">
                        <v-col cols="auto">
                            <h4>Total: {{ calculateaCartTotal }}</h4>
                        </v-col>
                    </v-row>
                </v-card>
                <!-- <v-row class="mt-4" justify="center">
                <v-btn color="primary" @click="proceedToPayment">Proceed to Payment Gateway</v-btn>
                </v-row> -->
                <br>
                <v-card class="box">
                    <v-toolbar class="toolbar" flat dense>
                        <v-toolbar-title>
                            <strong> Order Delivery Option </strong>
                        </v-toolbar-title>
                    </v-toolbar>

                    <v-row justify="center" dense>
                        <v-col cols="12" sm="4" md="4">
                            <p>
                                <v-icon color="error">*</v-icon><b>Delivery Options</b>
                            </p>
                            <v-autocomplete color="#0F2027" dense rounded required v-model="deliveryOption" :items="deliveryOptionList" item-text="name" item-value="id" label="Select Delivery Option" outlined persistent-hint hint="Select Delivery Option" @change="changeDeloveryOption(selectedDeliveryOption)" />
                        </v-col>
                    </v-row>
                    <!-- Conditional Sections Based on Delivery Option -->
                    <v-row class="mt-4" justify="center">
                        <!-- Home Delivery -->
                        <v-col v-if="deliveryOptionName == 'Home Delivery'" cols="12" sm="4">
                            <h4>Pickup From Home *</h4>
                            <v-textarea label="My Address" v-model="homeAddress" outlined required />
                            <v-text-field label="Pin" v-model="pinCode" outlined required />
                        </v-col>

                        <!-- Supplier Shop Pickup -->
                        <v-col v-if="deliveryOptionName == 'Supplier Shop'" cols="12" sm="7">
                            <v-row class="mt-4" justify="center">
                                <v-col cols="12" sm="8">
                                    <h4>Order Details</h4>
                                    <v-simple-table dense class="bordered-table">
                                        <thead>
                                            <tr>
                                                <th class="bold-header">Item</th>
                                                <th class="bold-header">Vendor</th>
                                                <th class="bold-header">Vendor Shop</th>
                                                <th class="bold-header">Address</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in supplierShopCartItems" :key="index">
                                                <td>{{ item.item }}</td>
                                                <td>{{ item.invvendor }}</td>
                                                <td>{{ item.vendorshop }}</td>
                                                <td>{{ item.vendorshop_address }}</td>
                                            </tr>
                                        </tbody>
                                    </v-simple-table>

                                </v-col>
                            </v-row>
                            <!-- <h4>Pickup From Shop</h4>
                            <v-select v-model="selectedShop" :items="filteredSupplierShopList" item-text="name" item-value="id" label="Supplier Shop" outlined dense required />
                            <v-textarea v-model="selectedShopDetails.address" label="Shop Address" outlined readonly />
                            <v-text-field v-model="selectedShopDetails.contact_email" label="Shop - Email" outlined dense />
                            <v-text-field v-model="selectedShopDetails.contact_mobile" label="Shop - Mobile" outlined dense />
                            <v-text-field v-model="selectedShopDetails.business_hours" label="Business Hours" outlined dense /> -->
                        </v-col>

                        <!-- School Pickup -->
                        <!-- <v-col v-if="deliveryOptionName == 'School Pickup'" cols="12" sm="4">
                            <h4>Pickup From School</h4>
                            <v-textarea label="School Address" v-model="homeAddress" outlined readonly />
                        </v-col> -->
                    </v-row>
                    <v-row justify="center" dense>
                        <v-col cols="12" sm="3" md="3">
                            <v-text-field label="Delivery Charges" v-model="totalDeliveryCharges" outlined readonly disabled />
                        </v-col>
                    </v-row>
                </v-card>

                <v-card class="box" v-if="payment_data != null && selectedDeliveryOption">
                    <v-toolbar flat dense class="toolbar">
                        <v-toolbar-title>Pay</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                        Wallet Balance - {{ wallet_balance }} Rs.
                    </v-toolbar>
                    <br>
                    <v-row justify="center" dense>
                        <!-- <v-col cols="12" sm="3" md="3">
                        <v-text-field label="Amount To Pay" v-model="faculty_canteen_fees" type="number" dense rounded readonly outlined hint="Please Enter Amount It's Rsequired"></v-text-field>
                    </v-col> -->
                        <form :action="url" @submit="payment" name="paytmform" method="POST">
                            <input type="hidden" :value="this.payment_data[0].orgid" name="orgid" />
                            <input type="hidden" :value="this.payment_data[0].tenantid" name="tenantid" />
                            <input type="hidden" :value="this.payment_data[0].uid" name="uid" />
                            <input type="hidden" :value="this.child" name="child" />
                            <input type="hidden" :value="prepareTransactionData" name="json_pre_trans_data" />
                            <input type="hidden" :value="calculateaCartTotal+this.totalDeliveryCharges" name="fee_amount" />

                            <v-btn class="button" type="submit" :loading="loader" color="warning" :disabled="isProceedToPayDisabled">
                                Proceed to Pay
                            </v-btn>
                        </form>
                        <v-btn class="button" type="submit" :loading="loader" color="warning" :disabled="isProceedToPayDisabled || isWalletBalanceLow" @click="payWithWallet()">
                            Pay With Wallet
                        </v-btn>
                        <marquee v-if="isWalletBalanceLow" class="low-balance-message">
                            Your wallet balance is insufficient to proceed. Please add funds to your wallet.
                        </marquee>
                    </v-row>
                </v-card>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDeliveryInstructions" max-width="500px">
            <v-card>
                <v-toolbar flat class="toolbar">
                    <v-toolbar-title>Add Delivery Instructions</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn fab small color="white" outlined icon @click="closeDeliveryDialog">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <br>
                <v-card-text>
                    <v-textarea v-model="deliveryInstructions" label="Enter Delivery Instructions" outlined rows="4" required></v-textarea>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" v-if="deliveryInstructions" @click="saveDeliveryInstructions">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- Tracking Details Dialog -->
        <v-dialog v-model="trackingDialog" max-width="600px">
            <v-card>
                <v-toolbar flat class="toolbar">
                    <v-toolbar-title>Order Tracking</v-toolbar-title>
                </v-toolbar>
                <v-card-title>
                    Track Order
                    <v-spacer></v-spacer>
                    <v-btn icon @click="trackingDialog=false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text>
                    <v-simple-table dense class="mytable " style="width: 100%;">
                        <thead>
                            <tr>
                                <th>S.No</th>
                                <th>Date</th>
                                <th>Status</th>
                                <th>Action By</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in trackingDetails" :key="item.id">
                                <td>{{ index + 1 }}</td>
                                <td>{{ item.action_date }}</td>
                                <td>{{ item.deliverystatus }}</td>
                                <td>{{ item.actionby === "null:--" ? "--" : item.actionby }}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="trackingDialog=false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
    <v-dialog v-model="videoDialog" max-width="1000px">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center grey lighten-4">
          <span style="color:black">My Orders Tutorial</span>
          <v-btn icon @click="videoDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-responsive :aspect-ratio="16/9">
           <iframe
              v-if="videoDialog"
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/unREE0kXmvI?si=Q3jisuK4y1iPIgXa"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </v-responsive>
        </v-card-text>
      </v-card>
    </v-dialog>
</div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css";
export default {
    data: () => ({
        allow_all_items_compulsory: false,
        searchQuery: "", // For search functionality
        orderItemsDialog: false,
        selectedOrderItems: [],
        videoDialog:false,
        orderItemsHeaders: [{
                text: 'Item Name',
                value: 'itemName'
            },
            {
                text: 'Quantity',
                value: 'quantity'
            },
            {
                text: 'Base Price',
                value: 'base_price'
            },
            {
                text: 'Tax',
                value: 'tax'
            },
            {
                text: 'Total Price',
                value: 'price'
            },
            {
                text: 'Delivery Status',
                value: 'deliverystatus'
            },
        ],
        wallet_balance: 0,
        showInvoiceDialog: false,
        invoice: {}, // Invoice details
        invoiceDetails: [], // Item list
        invoiceHeaders: [{
                text: "Item Name",
                value: "item_name"
            },
            {
                text: "Quantity",
                value: "quantity"
            },
            {
                text: "Amount",
                value: "amount"
            },
            {
                text: "Tax",
                value: "tax"
            },
            {
                text: "Total",
                value: "total"
            },
        ],
        trackingDetails: [],
        trackingDialog: false,
        dialogDeliveryInstructions: false, // Control the visibility of the dialog
        deliveryInstructions: '', // Store the delivery instructions entered by the user
        orderId: null, // Store the orderId for which delivery instructions are being added
        homeAddress: '',
        pinCode: '',
        supplierShopList: [],
        selectedShop: "",
        deliveryOptionList: [],
        deliveryOption: "",
        deliveryOptionName: "",
        cartItems: [],
        dialogCartSummary: false,
        itemCategory: null, // Selected Category
        selectedSizeLabelType: null, // Selected Size Label Type
        cartitems: [], // Selected Items
        selectedSizeLabels: [], // Selected Size Labels
        itemCategoryList: [], // List of Categories
        sizeLabelTypeList: [], // List of Size Label Types
        itemList: [], // Full list of items
        sizeLabelList: [], // Full list of Size Labels
        filteredItemList: [], // Filtered list of items based on category
        filteredSizeLabelList: [], // Filtered list of size labels based on selected size label type
        dialogAddOrder: false,
        loader: false,
        snackbar_msg: "",
        color: "",
        snackbar: false,
        overlay: false,
        headers: [{
                text: "SR.No",
                value: "srno"
            },
            {
                text: 'Order ID',
                value: 'orderid'
            },
            {
                text: 'Order Date',
                value: 'order_date'
            },
            {
                text: 'Total Amount',
                value: 'total_amount'
            },
            {
                text: 'Order Status',
                value: 'orderstatus'
            },
            {
                text: 'Delivery Option',
                value: 'deliveryoption'
            },
            {
                text: 'Delivery Instruction',
                value: 'delivery_instructions'
            },
            {
                text: 'View Invoice',
                value: 'viewDetails'
            },
            {
                text: 'Order Items',
                value: 'viewOrderItems',
                sortable: false
            },
            {
                text: 'Action',
                value: 'action',
                sortable: false
            },
            {
                text: 'Delivery Instructions Action',
                value: 'delivery_instructions_action',
                sortable: false
            },
        ],
        child_list: [],
        child: "",
        orders_list: [],
        studentDetails: null,
        headersItems:[],
        headersCart: [{
                text: "S.No",
                value: "srno"
            },
            {
                text: "Item Type",
                value: "itemcategory"
            },
            {
                text: "Item Name",
                value: "name"
            },
            {
                text: "Item Image",
                value: "item_image"
            },
            {
                text: "Item Description",
                value: "description"
            },
            {
                text: "Size Label",
                value: "sizelabel"
            },
            {
                text: "Size Chart",
                value: "sizechart_description"
            },
            {
                text: "Unit Price",
                value: "price"
            },
            {
                text: "Quantity",
                value: "quantity"
            },
            {
                text: "Total Price",
                value: "total_price"
            },
            {
                text: "Action",
                value: 'action',
                align: 'center',
                sortable: false
            } 
        ],
        pg_loader: false,
        payment_data: null,
        basepath: null
    }),
    methods: {
         onStudentChange() {
            this.studentDetails = null;
            this.orders_list = [];
            this.filteredItemList = [];
            this.cartItems = [];
            this.searchQuery = "";

            this.deliveryOption = null;
            this.deliveryOptionName = null;
            this.totalDeliveryCharges = 0;

            this.getMyOrders();
        },
        updateSelectedItemId(item) {
            if (item.selectedSize) {
                const sizeOptions = item.sizelabelId;
                const selectedSizeObj = sizeOptions.find(size => size.sizelabelId == item.selectedSize); 
                if (selectedSizeObj) {
                    item.selectedSize = {
                        id: selectedSizeObj.sizelabelId, 
                        name: selectedSizeObj.name, 
                        item_id: selectedSizeObj.item_id || null 
                    };
                    item.description = selectedSizeObj.description;
                    item.price = selectedSizeObj.price;
                    item.base_price = selectedSizeObj.base_price;
                    item.image_file_path = selectedSizeObj.image_file_path;
                    item.selectedSize = selectedSizeObj.sizelabelId; // Update selected size ID
                    item.id = selectedSizeObj.item_id; // Update the item ID if needed
                    item.total_price = item.price; 

                }
            }
        },

        getSizeLabels(item) {
            if (!item.sizelabelId || item.sizelabelId.length === 0) {
                return [];
            }
            const sizeLabelIds = item.sizelabelId.map(size => size.sizelabelId);
            return this.sizeLabelList.filter(label => sizeLabelIds.includes(label.id)); 
        },

        closeDialog() {
            this.dialogAddOrder = false;
            this.itemCategory = null;
            this.filteredItemList = [];
        },
        updateQuantity(item, type) {
            if (!confirm("Are You Sure You Want To Update Cart...?")) return;
            const data = {
                cartId: item.id,
                child: this.child,
                type: type
            };
            this.overlay = true;
            axios.post("/EduStore/updateCartQuantity", data)
                .then((res) => {
                    if (res.data.flag === "YES") {
                        this.cartItems = res.data.cartItems; 
                        this.showSnackbar("green", "Updated Successfully...");
                    } else if (res.data.flag === "No") {
                        this.showSnackbar("red", res.data.snackbar);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.onerror(error);
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                    this.calculateTotal();
                });
        },
        fnExcelReport(id, name) {
            var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
            tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
            tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
            tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
            tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
            tab_text = tab_text + "<table border='1px'>";
            var exportTable = $("#" + id).clone();
            exportTable.find("input").each(function (index, elem) {
                $(elem).remove();
            });
            tab_text = tab_text + exportTable.html();
            tab_text = tab_text + "</table></body></html>";
            var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";
            const blob = new Blob([tab_text], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            const filename = name + '.xls';

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                a.click();
                window.URL.revokeObjectURL(url);
            }
        },
        viewImage(imagePath) {
            if (imagePath) {
                const fullImageUrl = `${this.basepath}${imagePath}`;
                window.open(fullImageUrl, "_blank");
            } else {
                console.warn("No image path provided.");
            }
        },
        showOrderItems(order) {
            this.selectedOrderItems = order.orderItems || [];
            this.orderItemsDialog = true; 
        },
        payWithWallet() {
            if (!confirm("Are You Sure You Want To Pay With Wallet...?")) return;
            const data = {
                child: this.child,
                json_pre_trans_data: this.prepareTransactionData,
                total_value: this.calculateaCartTotal + this.totalDeliveryCharges
            };
            this.overlay = true;
            axios.post("/EduStore/payWithWallet", data)
                .then((res) => {
                    if (res.data.flag === "YES") {
                        this.showSnackbar("green", "Order Placed Successfully...");
                        this.dialogCartSummary = false,
                            this.dialogAddOrder = false,
                            this.filterItems = [],
                            this.cartItems = []
                    } else if (res.data.flag === "No") {
                        this.showSnackbar("red", res.data.snackbar);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.onerror(error);
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                    this.getMyOrders();
                });
        },
        showInvoice(item) {
            localStorage.setItem("invoice_id", item);
            let routeData = this.$router.resolve({
                name: "view-invoice-edustore"
            });
            window.open(routeData.href, "_blank");
        },
        viewInvoice(orderId) {
            const data = {
                orderId: orderId,
            };
            this.overlay = true;
            axios.post("/EduStore/viewInvoice", data)
                .then((res) => {
                    if (res.data.flag === "YES") {
                        this.invoice = res.data.invoice;
                        this.invoiceDetails = res.data.invoiceDetails;
                    } else if (res.data.flag === "No") {
                        this.showSnackbar("red", res.data.snackbar);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.onerror(error);
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                    this.showInvoiceDialog = true
                });
        },
        cancelOrder(orderId) {
            if (!confirm("Are You Sure You Want To Cancel This Order...?")) return;
            const data = {
                orderId: orderId,
                child: this.child
            };
            this.overlay = true;
            axios.post("/EduStore/cancelOrder", data)
                .then((res) => {
                    if (res.data.flag === "YES") {
                        this.orders_list = res.data.orders_list
                        this.showSnackbar("green", "Order Cancelled...Amount Refunded To Wallet Successfully...");
                    } else if (res.data.flag === "No") {
                        this.showSnackbar("red", res.data.snackbar);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.onerror(error);
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        getOrderTrackingDetails(orderId) {
            const data = {
                orderId: orderId,
                child: this.child
            };
            this.overlay = true;
            axios.post("/EduStore/getOrderTrackingDetails", data)
                .then((res) => {
                    if (res.data.flag === "YES") {
                        this.trackingDetails = res.data.tracking_details
                        this.trackingDialog = true
                    } else if (res.data.flag === "No") {
                        this.showSnackbar("red", res.data.snackbar);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.onerror(error);
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        saveDeliveryInstructions() {
            const data = {
                orderId: this.orderId,
                deliveryInstructions: this.deliveryInstructions,
                child: this.child
            };
            this.overlay = true;
            axios.post("/EduStore/saveDeliveryInstructions", data)
                .then((res) => {
                    if (res.data.flag === "YES") {
                        this.orders_list = res.data.orders_list
                        this.dialogDeliveryInstructions = false;
                        this.showSnackbar("green", "Instructions Added Successfully...");
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.onerror(error);
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                    this.dialogDeliveryInstructions = false;
                });
        },
        openDeliveryDialog(orderId) {
            this.orderId = orderId.id;
            this.deliveryInstructions = orderId.delivery_instructions
            this.dialogDeliveryInstructions = true;
        },
     
        closeDeliveryDialog() {
            this.dialogDeliveryInstructions = false;
            this.deliveryInstructions = ''; 
        },
        getSelectedAddress() {
            if (this.deliveryOptionName === 'Home Delivery') {
                return this.homeAddress;
            } else if (this.deliveryOptionName === 'Supplier Shop') {
                return 'Supplier Shop';
            } else if (this.deliveryOptionName === 'School Pickup') {
                return this.homeAddress;
            }
            return '';
        },
        payment() {
            this.loader = true
            var formData = new FormData(paytmform);
            this.pg_loader = false;
        },
        changeDeloveryOption(item) {
            this.deliveryOptionName = item.name
            if (this.deliveryOptionName === "Home Delivery" && this.studentDetails.local_address) {
                this.homeAddress = this.studentDetails.local_address;
            } else if (this.deliveryOptionName === "School Pickup" && this.studentDetails.schol_address) {
                this.homeAddress = this.studentDetails.schol_address;
            } else {
                this.homeAddress = "";
            }
        },
        
        addItemToCart() {
            this.loader = true;
            const payload = {
                itemIds: this.filteredItemList
                    .filter(item => item.selected)
                    .map(item => {
                        return item.id; 
                    }),

                quantities: this.filteredItemList
                    .filter(item => item.selected)
                    .map(item => item.quantity),

                prices: this.filteredItemList
                    .filter(item => item.selected)
                    .map(item => item.price),

                total_price: this.filteredItemList
                    .filter(item => item.selected)
                    .map(item => item.total_price),

                child: this.child
            };

            this.overlay = true;
            axios.post("/EduStore/addItemsToCart", payload)
                .then((res) => {
                    if (res.data.flag === "YES") {
                        this.cartItems = res.data.cartItems;
                        this.showSnackbar("green", "Item Added Successfully");
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        if (res.data.error_trace) {
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    }
                })
                .catch((error) => {
                    this.onerror(error);
                })
                .finally(() => {
                    this.overlay = false;
                    this.loader = false;
                });
        },

        proceed() {
            this.dialogAddOrder = false;
            this.dialogCartSummary = true;

            const payload = {
                itemIds: this.filteredItemList
                    .filter(item => item.selected)
                    .map(item => {
                        return item.id;
                    }),

                quantities: this.filteredItemList
                    .filter(item => item.selected)
                    .map(item => item.quantity),

                prices: this.filteredItemList
                    .filter(item => item.selected)
                    .map(item => item.price),

                total_price: this.filteredItemList
                    .filter(item => item.selected)
                    .map(item => item.total_price),

                child: this.child
            };

            this.overlay = true;
            axios.post("/EduStore/addItemsToCart", payload)
                .then((res) => {
                    if (res.data.flag === "YES") {
                        this.cartItems = res.data.cartItems;
                    } else if (res.data.flag === "No") {
                        this.showSnackbar("red", res.data.snackbar);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })
                .catch((error) => {
                    this.onerror(error);
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        removeFromCart(item) {
            if (!confirm("Are You Sure You Want To Remove Item From Cart...?")) return;
            const data = {
                cartId: item.id,
                child: this.child
            };
            this.overlay = true;
            axios.post("/EduStore/removeItemFromCart", data)
                .then((res) => {
                    if (res.data.flag === "YES") {
                        this.cartItems = res.data.cartItems; 
                        this.showSnackbar("green", "Removed Successfully...");
                    } else if (res.data.flag === "No") {
                        this.showSnackbar("red", res.data.snackbar);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.onerror(error);
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        updateTotalPrice(item) {
            if (item.total_price === undefined) {
                this.$set(item, 'total_price', 0); 
            }
            if (item.quantity > item.availableStockQuantity) {
                this.$toast.error(`Only ${item.availableStockQuantity} items are available in stock.`); 
                item.quantity = item.availableStockQuantity; 
            }

            item.total_price = item.price * item.quantity; 
        },
        closeCartDialog() {
            this.dialogCartSummary = false;
            this.dialogAddOrder = true
        },
        saveOrder() {
            const data = {
                child: this.child,
                orders: this.filteredItemList.filter(item => item.selected).map(item => ({
                    itemId: item.id,
                    quantity: item.quantity,
                    totalPrice: item.total_price,
                })),
            };
            this.overlay = true;
            axios
                .post("/EduStore/saveOrder", data)
                .then((res) => {
                    if (res.data.flag === "YES") {
                        this.showSnackbar("green", "Order saved successfully!");
                        this.filteredItemList.forEach(item => {
                            item.selected = false;
                            item.quantity = 1; 
                            item.total_price = item.unit_price; 
                        });
                        this.getMyOrders();
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })
                .catch((error) => {
                    this.onerror(error);
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        fetchFilteredItems() {
            const data = {
                itemCategory: this.itemCategory,
                selectedSizeLabelType: this.selectedSizeLabelType,
                cartitems: this.cartitems,
            };

            this.overlay = true; // Show loading overlay
            axios.post("/EduStore/getFilteredItems", data)
                .then((res) => {
                    if (res.data.flag === "YES") {
                        this.filteredItemList = res.data.filteredItemList || [];
                        this.filteredSizeLabelList = res.data.filteredSizeLabelList || [];

                        if (this.filteredItemList.length <= 0 && this.filteredSizeLabelList.length <= 0) {
                            this.showSnackbar("red", "No Data Found..");
                        }
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.onerror(error);
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
       
        filterItems() {
            if (this.itemCategory) {
                this.filteredItemList = this.itemList
                    .filter(item => item.itemcategoryId === this.itemCategory)
                    .map(item => ({
                        ...item,
                        selected: this.allow_all_items_compulsory ? true : item.selected,
                        quantity: this.allow_all_items_compulsory ? 1 : (item.quantity || 1), // Ensure default quantity
                        total_price: (item.price || 0) * (this.allow_all_items_compulsory ? 1 : (item.quantity || 1)) // Prevent NaN
                    }));
            } else {
                this.filteredItemList = this.itemList.map(item => ({
                    ...item,
                    selected: this.allow_all_items_compulsory ? true : item.selected,
                    quantity: this.allow_all_items_compulsory ? 1 : (item.quantity || 1),
                    total_price: (item.price || 0) * (this.allow_all_items_compulsory ? 1 : (item.quantity || 1))
                }));
            }
        },
        filterSizeLabels() {
            if (this.selectedSizeLabelType) {
                this.filteredSizeLabelList = this.sizeLabelList.filter(label => label.sizelabeltypeid === this.selectedSizeLabelType);
            } else {
                this.filteredSizeLabelList = this.sizeLabelList;
            }
        },
        getMyOrders() {
            const data = {
                child: this.child
            };
            this.overlay = true;
            axios.post("/EduStore/getMyOrders", data)
                .then((res) => {
                    if (res.data.flag === "YES") {
                        this.allow_all_items_compulsory = res.data.allow_all_items_compulsory;
                        this.orders_list = res.data.orders_list;
                        this.itemCategoryList = res.data.itemCategoryList;
                        this.sizeLabelTypeList = res.data.sizeLabelTypesList;
                        this.sizeLabelList = res.data.sizeLabelsList;
                        this.itemList = res.data.itemList;
                        this.deliveryOptionList = res.data.deliveryOptionList;
                        this.supplierShopList = res.data.supplierShopList;
                        this.payment_data = res.data.payment_data
                        this.wallet_balance = res.data.wallet_balance
                        if (this.orders_list.length <= 0) {
                            this.showSnackbar("red", "No Data Found..");
                        }
                        this.studentDetails = {
                            registration_number: res.data.registration_number,
                            learner_name: res.data.learner_name,
                            standard: res.data.standard,
                            division: res.data.division,
                            local_address: res.data.local_address,
                            schol_address: res.data.schol_address
                        };
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.onerror(error);
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        placeOrder() {
            this.dialogAddOrder = true
        },

        addDeliveryInstructions(orderId) {
            this.showSnackbar("green", `Adding delivery instructions for Order ID: ${orderId}`);
        },

        onLoad() {
            axios.post("Admission/getAllStudents")
                .then((res) => {
                    if (res.data.msg === "200") {
                        this.child_list = res.data.stud_list;
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    }
                })
                .catch(() => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
    },
    watch: {
        selectedSizeLabelType(newVal) {
            this.filterSizeLabels();
        },
       
        itemCategory(newVal) {
            this.filterItems();
        },
    },
    computed: {
        dynamicHeaders() {
        let headers = [
            { text: "Item Type", value: "itemcategory" },
            { text: "Item Name", value: "name" },
            { text: "Item Image", value: "item_image" },
            { text: "Item Description", value: "description" },
            { text: "Size Chart", value: "sizechart_file_path" },
            { text: "Unit Price", value: "price" },
            { text: "Select", value: "select" },
            { text: "Quantity", value: "quantity" },
            { text: "Total Price", value: "total_price" }
        ];

        if (!this.allow_all_items_compulsory) {
            headers.splice(4, 0, { text: "Size Label", value: "sizelabel", sortable: false });
            headers.splice(8, 0, { text: "Available Quantity", value: "availableStockQuantity", sortable: false });
        } else {
            headers.push({ text: "Size Label", value: "size_label", sortable: false });
        }

        return headers;
    },
        supplierShopCartItems() {
            return this.deliveryOptionName === 'Supplier Shop' ?
                this.cartItems.map(item => ({
                    item: item.name,
                    invvendor: item.invvendor,
                    vendorshop: item.vendorshop || 'N/A',
                    vendorshop_address: item.vendorshop_address || 'N/A',
                })) : [];
        },
        filteredSupplierShopList() {
            if (this.deliveryOptionName != 'Supplier Shop') {
                return this.supplierShopList;
            }
            const cartVendorIds = new Set(this.cartItems.map(item => item.invvendorId));
            return this.supplierShopList.filter(shop => cartVendorIds.has(shop.invvendorId));
        },
        calculateaCartTotal() {
            let total = this.cartItems.reduce((sum, item) => sum + item.total_price, 0);
            return total;
        },
        calculateTotal() {
            return this.filteredItemList
                .filter(item => item.selected) 
                .reduce((sum, item) => sum + (item.total_price || 0), 0);
        },
        selectedDeliveryOption() {
            return this.deliveryOptionList.find(option => option.id === this.deliveryOption) || {};
        },
        selectedShopDetails() {
            return this.supplierShopList.find(shop => shop.id === this.selectedShop) || {};
        },
        prepareTransactionData() {
            return JSON.stringify({
                totalAmount: this.calculateaCartTotal,
                items: this.cartItems.map(item => ({
                    id: item.itemId,
                    quantity: item.quantity,
                    total_price: item.total_price
                })),
                address: this.getSelectedAddress(),
                deliveryOption: this.deliveryOption
            });
        },
       
        isProceedDisabled() {
            const isTotalInvalid = this.calculateTotal <= 0;

            const hasInvalidSize = this.filteredItemList.some(item =>
                item.selected && item.is_size_applicable && !item.selectedSize
            );

            const hasInvalidQuantityOrStock = !this.allow_all_items_compulsory &&
                this.filteredItemList.some(item =>
                    item.selected && (
                        !item.quantity || item.quantity <= 0 ||
                        item.availableStockQuantity <= 0 
                    )
                );

            return isTotalInvalid || hasInvalidSize || hasInvalidQuantityOrStock;
        },

        isProceedToPayDisabled() {
            const selectedAddress = this.getSelectedAddress();
            return !selectedAddress || this.cartItems.length === 0 || !this.deliveryOptionName;
        },
        totalDeliveryCharges() {
            let uniqueVendors = new Set();
            let totalCharges = 0;

            this.cartItems.forEach((item) => {
                if (!uniqueVendors.has(item.invvendorId)) {
                    uniqueVendors.add(item.invvendorId);
                    totalCharges += item.delivery_charges;
                }
            });

            return totalCharges;
        },
        isWalletBalanceLow() {
            const totalCartCost = this.calculateaCartTotal + this.totalDeliveryCharges;
            return this.wallet_balance < totalCartCost;
        }
    },
    mounted() {
        this.onLoad();
        this.basepath = localStorage.getItem("awspath");
    },
    created() {
        this.url = process.env.VUE_APP_API_URL + "/paymentGatewayPayTM/paytmEduStoreOrder";
    },
};
</script>

<style scoped>
.search-bar {
    max-width: 450px;
    margin-right: 70px;
}

.search-bar input {
    color: white !important;
}

.export-btn {
    background-color: #4CAF50;
    color: white;
}

.cursor-pointer {
    cursor: pointer;
}

.styled-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    font-size: 14px;
}

.styled-table th,
.styled-table td {
    text-align: center;
    padding: 12px;
    border: 1px solid #ddd;
}

.styled-table th {
    background-color: #0f0464;
    color: white;
    font-weight: bold;
}

.styled-table tr:nth-child(even) {
    background-color: #f9f9f9;
}

.styled-table tr:hover {
    background-color: #f1f1f1;
}

.bordered-table {
    border: 1px solid #ddd;
    border-collapse: collapse;
    width: 100%;
}

.bordered-table th,
.bordered-table td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: left;
}

.bold-header {
    font-weight: bold;
    background-color: #f5f5f5;
}
</style>
